import React from 'react';
import { StyledHeadCellToolbar, ToolbarWrap, ActionsBlock } from './styled';
const renderTableToolbarMap = {
    table: ({ children }) => (React.createElement("tr", null,
        React.createElement(StyledHeadCellToolbar, { colSpan: 10000 },
            React.createElement(ToolbarWrap, null, children)))),
    block: ({ children }) => (React.createElement("div", { role: "toolbar" },
        React.createElement(StyledHeadCellToolbar, { as: "div", role: "cell" },
            React.createElement(ToolbarWrap, null, children))))
};
export const TableToolbar = ({ actions, selectedRowIds, selectedFlatRows, layoutType }) => {
    const TableToolbarLayout = renderTableToolbarMap[layoutType];
    return (React.createElement(TableToolbarLayout, null,
        React.createElement(ActionsBlock, null, actions === null || actions === void 0 ? void 0 : actions.map((Action, index) => (React.createElement(Action, { key: index, selectedRowIds: selectedRowIds, selectedFlatRows: selectedFlatRows }))))));
};
